import classNames               from 'classnames';
import * as React               from 'react';
import { Link, useHistory }     from 'react-router-dom';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide }  from 'swiper/react';
import DV                       from 'ts-data-validator';

import 'swiper/swiper-bundle.css';
import './style.scss';

import needReset      from '../../../common/tools/need-reset';
import { useCatalog } from '../../../providers/catalog';

const HomePageSlider = function(props) {
  const { images } = props;

  const history          = useHistory();
  const { resetCatalog } = useCatalog();

  const sliderRef = React.useRef(null);

  const [isMobile, setIsMobile] = React.useState(false);

  const onAutoplayTimeLeft = React.useCallback((swiper, _, progress) => {
    const sliderEl = sliderRef.current;

    if (!sliderEl) {
      return;
    }

    const activeBullet = sliderEl.querySelector(`.swiper-pagination-bullet[data-bullet-index="${swiper.realIndex}"]`);

    if (activeBullet) {
      const fillProgress = Math.round(Math.max(0, Math.min(100, (1 - progress) * 100)));

      activeBullet.style.setProperty('--bullet-progress', `${fillProgress}%`);
    }
  }, []);
  const onSlideChange      = React.useCallback((swiper) => {
    const sliderEl = sliderRef.current;

    if (!sliderEl) {
      return;
    }

    const bullets = sliderEl.querySelectorAll('.swiper-pagination-bullet');

    bullets.forEach((bullet) => {
      bullet.style.setProperty('--bullet-progress', '0%');
    });

    const activeBullet = sliderEl.querySelector(`.swiper-pagination-bullet[data-bullet-index="${swiper.realIndex}"]`);

    if (activeBullet) {
      activeBullet.style.setProperty('--bullet-progress', '0%');
    }
  }, []);

  const handleClick = React.useCallback((event, url) => {
    event.stopPropagation();

    if (needReset(url)) {
      resetCatalog();
    }
  }, [needReset, resetCatalog]);

  React.useEffect(() => {
    const handleResize = () => {
      const tabletAndLess = window.innerWidth < 768;

      setIsMobile((prev) => {
        return (prev === tabletAndLess
            ? prev
            : tabletAndLess
        );
      });
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={'slider-container'} ref={sliderRef}>
      <Swiper
        autoplay={{
          delay:                5000,
          disableOnInteraction: false,
        }}
        loop
        modules={[Autoplay, Pagination]}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        onSlideChange={onSlideChange}
        pagination={{
          clickable:    true,
          renderBullet: (index, className) => {
            return `<span class="${className}" data-bullet-index="${index}"></span>`;
          },
        }}
        slidesPerView={1}
        speed={5e2}
      >
        {images.map((image) => {
          if (!image) {
            return null;
          }

          return (
            <SwiperSlide key={image.id}>
              <div
                className={
                  classNames('slide_wrapper', {
                    clickable: image.firstBtnLink || image.link,
                  })
                }
              >
                <div
                  className={'slide'}
                  onClick={(event) => {
                    {/*BX-78796: в мобильной версии при клике на картинку а в дескопной при клике на кнопку*/
                    }
                    if (isMobile && DV.isNotEmptyString(image.firstBtnLink)) {
                      handleClick(event, image.firstBtnLink);

                      history.push(image.firstBtnLink);
                    }
                  }}
                >
                  <picture className="slide-picture">
                    {/*BX-78796: если не задали картинку для мобильной версии будем отображать десктопную*/}
                    {DV.isNotEmptyString(image.mobileImgLink)
                      ? (
                        <>
                          <source
                            srcSet={`${image.mobileImgLink}.webp`}
                            media="(max-width: 479px)"
                            type="image/webp"
                          />
                          <source
                            srcSet={`${image.mobileImgLink}.png`}
                            media="(max-width: 479px)"
                            type="image/png"
                          />
                        </>
                      ) : (
                        <>
                          <source
                            srcSet={`${image.imgLink}.webp`}
                            media="(max-width: 479px)"
                            type="image/webp"
                          />
                          <source
                            srcSet={`${image.imgLink}.png`}
                            media="(max-width: 479px)"
                            type="image/png"
                          />
                        </>
                      )}
                    <source
                      srcSet={`${image.imgLink}.webp`}
                      media="(min-width: 480px)"
                      type="image/webp"
                    />
                    <source
                      srcSet={`${image.imgLink}.png`}
                      media="(min-width: 480px)"
                      type="image/png"
                    />
                    <img
                      src={`${(image.mobileImgLink || image.imgLink)}.png`}
                      alt={image?.alt || ''}
                      className="slide-image"
                    />
                  </picture>

                  <div className={'content_container'}>
                    <div className={'title'} dangerouslySetInnerHTML={{ __html: image.title }} />
                    <div className={'btn_conteiner'}>
                      {!isMobile && image.isShowFirstBtn && image.firstBtnLink && (
                        <Link
                          className={'btn'}
                          to={image.firstBtnLink}
                          onClick={(event) => {
                            {/*BX-78796: в мобильной версии при клике на картинку а в дескопной при клике на кнопку*/
                            }
                            if (DV.isNotEmptyString(image.firstBtnLink)) {
                              handleClick(event, image.firstBtnLink);
                            }
                          }}
                        >
                          {image.firstBtnText || ''}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default HomePageSlider;